<template>
  <div class="month-selector">
    <button :disabled="cantGoLeft" class="month-selector-button" @click="goLeft">
      <FontAwesomeIcon icon="chevron-left"/>
    </button>
    <div class="month-selector-date">
      {{ selectedDate.format('MMMM YYYY') }}
    </div>
    <button :disabled="cantGoRight" class="month-selector-button" @click="goRight">
      <FontAwesomeIcon icon="chevron-right"/>
    </button>
  </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import dayjs from 'dayjs';

library.add(faChevronLeft, faChevronRight);

const today = dayjs();
const CURRENT_YEAR = today.year();
const CURRENT_MONTH = today.month();

export default {
  name: 'MonthSelector',
  props: {
    value: {
      type: String, // 2021-06-01
      required: true
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    firstDate: {
      type: Object,
      required: false
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    selectedDate: { // type: dayjs
      get() { return this.value ? dayjs(this.value) : dayjs(); },
      set(val) { this.$emit('input', val.format(this.format)); }
    },
    cantGoRight() {
      return this.isCurrentMonth(this.selectedDate);
    },
    cantGoLeft() {
      if (!this.firstDate) {
        return false;
      }
      return this.firstDate.month() === this.selectedDate.month() && this.firstDate.year() === this.selectedDate.year();
    }
  },
  methods: {
    goLeft() {
      if (this.cantGoLeft) {
        return;
      }
      this.selectedDate = this.selectedDate.subtract(1, 'month').set('date', 1);
    },
    goRight() {
      if (this.cantGoRight) {
        return;
      }
      this.selectedDate = this.selectedDate.add(1, 'month').set('date', 1);
    },
    isCurrentMonth(date) {
      return date.month() === CURRENT_MONTH && date.year() === CURRENT_YEAR;
    }
  }
};
</script>

<style lang="postcss">
.month-selector {
  @apply inline-flex items-center justify-between h-12;
  font-size: 22px;

  .month-selector-date {
    @apply w-48 text-center select-none;
  }

  .month-selector-button {
    @apply w-10 h-10 outline-none;

    &[disabled] {
      @apply text-gray-300 cursor-default pointer-events-none;
    }
  }
}
</style>